<template>
  <v-dialog v-model="active" max-width="350">
    <v-card>
      <v-card-title class="text-h5 text-center">
        <h5 class="fw">{{ title }}</h5>
      </v-card-title>

      <v-card-text>
        <v-combobox
          :items="items"
          v-model="selected"
          label="Search & Import"
          outlined
          clearable
          dense
        >
        </v-combobox>
      </v-card-text>

      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="red darken-1" text @click="close"> Cancel </v-btn>
        <v-spacer> </v-spacer>
        <v-btn color="success" @click="runAction" :disabled="!selected">
          <v-icon dark> mdi-cloud-upload </v-icon> Import
        </v-btn>
        <v-spacer> </v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { SelectItem } from "@/types";
import Vue from "vue";

export default Vue.extend({
  name: "ImportModal",

  data() {
    return {
      selected: undefined,
    };
  },
  computed: {
    modal(): any {
      return this.$store.getters.getImportDialog;
    },
    active: {
      get(): boolean {
        return this.modal.active;
      },
      set(val: boolean) {
        this.$store.commit("setImportDialogActive", val);
      },
    },
    items(): SelectItem[] {
      return this.modal.items;
    },
    action(): any {
      return this.modal.action;
    },
    args(): any {
      return this.modal.args;
    },
    title(): string {
      return this.modal.title;
    },
  },
  methods: {
    runAction() {
      this.action(this.selected, this.args);
      this.close();
    },
    close() {
      this.active = false;
      this.clear();
    },
    clear() {
      this.selected = null;
    },
  },
});
</script>
<style scoped></style>
